import * as React from 'react'

import Stack from '@mui/material/Stack'
import { TextField as Input, Grid } from '@mui/material'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import Select from 'components/atomic/atoms/select'
import { Difficulty, PathGoal } from 'types/types'

interface SearchBarProps {
    filters: {
        search: string
        difficulty: Difficulty | ''
        type: PathGoal | ''
    }
    onChange: (filters: { search: string; difficulty: Difficulty | ''; type: PathGoal | '' }) => void
}

const SearchBar = React.memo((props: SearchBarProps) => {
    const { t }: I18n = useTranslation()

    const difficulties = React.useMemo((): { label: string; value: Difficulty | '' }[] => {
        return [
            {
                label: 'Tutte',
                value: '',
            },
            {
                label: t('common:difficulty.BEGINNER'),
                value: 'BEGINNER',
            },
            {
                label: t('common:difficulty.INTERMEDIATE'),
                value: 'INTERMEDIATE',
            },
            {
                label: t('common:difficulty.ADVANCED'),
                value: 'ADVANCED',
            },
        ]
    }, [t])

    const type = React.useMemo((): { label: string; value: PathGoal | '' }[] => {
        return [
            {
                label: 'Tutti',
                value: '',
            },
            {
                label: t('common:pathGoal.career'),
                value: 'career',
            },
            {
                label: t('common:pathGoal.skill'),
                value: 'skill',
            },
            {
                label: t('common:pathGoal.course'),
                value: 'course',
            },
        ]
    }, [t])

    return (
        <Grid spacing="1rem" container>
            <Grid item xs={12} md>
                <Input
                    size="small"
                    fullWidth
                    label={t('catalog:inputs.search')}
                    onChange={(event) => props.onChange({ ...props.filters, search: event.target.value })}
                />
            </Grid>
            <Grid item xs={12} md="auto">
                <Stack spacing="1rem" direction="row">
                    <Select
                        size="small"
                        label={t('catalog:inputs.difficulty')}
                        options={difficulties}
                        sx={{ minWidth: '10rem' }}
                        onChange={(event) =>
                            props.onChange({ ...props.filters, difficulty: event.target.value as Difficulty })
                        }
                    />
                    <Select
                        size="small"
                        label={t('catalog:inputs.types')}
                        options={type}
                        sx={{ minWidth: '10rem' }}
                        onChange={(event) => props.onChange({ ...props.filters, type: event.target.value as PathGoal })}
                    />
                </Stack>
            </Grid>
        </Grid>
    )
})

export default SearchBar
